export const RETAIL_MEDIA_APPS = [
  'Local Dev 5173',
  'Retail Media Ads',
  'Rokt',
  'Thanks Ads',
] as const;

export const GATEWAY_APPS = [...RETAIL_MEDIA_APPS, 'Abandoned Cart'] as const;
